import PaginationConfig from "@/entities/PaginationConfig";
import { Dictionary } from "vue-router/types/router";
import paginationConfig from "@/data/paginationConfig";

interface GetPaginationDataFromQueryResult {
  page: number;
  limit: number;
}

const getPaginationQuery = (paginationConfig: PaginationConfig) => {
  const {
    page,
    limit,
  } = paginationConfig;

  return {
    page: String(page),
    limit: String(limit),
  };
};

const getPaginationDataFromQuery = (query: Dictionary<string | (string | null)[]>): GetPaginationDataFromQueryResult => {
  const {
    page = paginationConfig.page,
    limit = paginationConfig.limit,
  } = query;

  return {
    page: Number(page),
    limit: Number(limit),
  };
}

export {
  getPaginationQuery,
  getPaginationDataFromQuery,
};